import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import DateSection from './formSections/date';
import DescriptionSection from './formSections/description';
import ShopSection from './formSections/shop';
import ImagesSection from './formSections/images';
import CheckboxesSection from './formSections/checkboxes';
import CommunicationsCheckboxes from './formSections/communicationsCheckboxes';

import { useTranslation } from 'react-i18next';

import useCoupons from '../useCoupons';
import NotificationFormForEdit from 'components/modules/notificationFormForEdit';
import moment from 'moment';

const EditCoupon = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    handleApprove,
    singleItem,
    form,
    updateInProcess,
    handleCreateOrUpdate,
    filterData,
    handleDeleteFile,
  } = useCoupons(false);
  const onFinish = async (params) => {
    await handleCreateOrUpdate(params);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew ? t('PUBBLICA COUPON') : t('MODIFICA COUPON');

  const isApproveOnly = singleItem.can_approve && !singleItem.can_update;

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
            author: '',
            date_from: moment().add(1, 'days'),
            date_to: moment().add(2, 'days'),
            published_at: moment().add(1, 'days'),
            until_last: false,
            description: '',
            staff_only: false,
            published: false,
            boolean: false,
            marketing_approved: false,
            retail_approved: false,
            expires_at: moment().add(2, 'days'),
            membership_expiration_date: moment().add(1, 'days'),
            company_id: '',
            is_archive: false,
            is_newsletter: false,
            is_radio: false,
            is_social: false,
            is_web: false,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <InfoSection isView={isApproveOnly} />
          <DateSection isView={isApproveOnly} />
          <DescriptionSection isView={isApproveOnly} />
          <ShopSection
            shops={filterData.companies}
            inactiveShops={filterData.inactive_companies}
            isView={isApproveOnly}
          />
          <ImagesSection
            isView={isApproveOnly}
            updateInProcess={updateInProcess}
            handleDeleteFile={handleDeleteFile}
            singleItem={singleItem}
            isEdit={!isNew}
          />
          <CheckboxesSection isView={isApproveOnly} />

          <CommunicationsCheckboxes isView={isApproveOnly} />
          {!isApproveOnly && (
            <Row gutter={16}>
              <Col>
                <Button
                  onClick={onClickSave}
                  width={'150px'}
                  big
                  loading={updateInProcess}
                  icon={<CheckOutlined />}
                >
                  {t('Invia')}
                </Button>
              </Col>
            </Row>
          )}
          {!isNew && (
            <NotificationFormForEdit
              loading={updateInProcess}
              handleOnFinish={handleApprove}
              showApprove={!!singleItem.can_approve}
              showReject={!!singleItem.can_reject}
              showToAdim={!!singleItem.can_to_admin}
              showRefuse={!!singleItem.can_refuse}
              approveKey={'publish'}
              rejectKey={'unpublish'}
            />
          )}
        </Form>
      </div>
    </div>
  );
};

export default EditCoupon;
